import type { ReactNode } from 'react';
import { Card, Tooltip } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';

export const integer = new Intl.NumberFormat('de-DE');
export const decimal = new Intl.NumberFormat('de-DE', { minimumFractionDigits: 1, maximumFractionDigits: 1 });
export const euro = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', maximumFractionDigits: 2 });
export const percentage = (part: number, total: number) =>
  total > 0 ? `${decimal.format((part / total) * 100)} %` : '—';
export const formatDate = (value: string) => new Date(value).toLocaleDateString('de-DE', { timeZone: 'UTC' });
export const formatUtcDateTime = (value: string) =>
  new Date(value).toLocaleString('de-DE', { timeZone: 'UTC', dateStyle: 'short', timeStyle: 'short' });
export const formatTime = (value: string) => new Date(value).toLocaleString('de-DE', { timeZone: 'Europe/Berlin' });

export function AnalyticsMetric({
  title,
  value,
  note,
  definition,
}: {
  title: string;
  value: string;
  note: string;
  definition: string;
}) {
  return (
    <Card className="analytics-metric">
      <div className="analytics-metric-label">
        <span>
          {title}{' '}
          <Tooltip title={definition} trigger={['hover', 'focus']}>
            <button type="button" className="analytics-info" aria-label={`Definition: ${title}`}>
              <InfoCircleOutlined />
            </button>
          </Tooltip>
        </span>
      </div>
      <strong>{value}</strong>
      <p>{note}</p>
    </Card>
  );
}

export function AnalyticsPanel({
  title,
  subtitle,
  children,
  extra,
}: {
  title: string;
  subtitle?: string;
  children: ReactNode;
  extra?: ReactNode;
}) {
  return (
    <Card className="analytics-panel">
      <header>
        <div>
          <h3>{title}</h3>
          {subtitle && <p>{subtitle}</p>}
        </div>
        {extra}
      </header>
      {children}
    </Card>
  );
}
